import { render, staticRenderFns } from "./GaoyangMap2.vue?vue&type=template&id=4b54d1dd&scoped=true&"
import script from "./GaoyangMap2.vue?vue&type=script&lang=js&"
export * from "./GaoyangMap2.vue?vue&type=script&lang=js&"
import style0 from "./GaoyangMap2.vue?vue&type=style&index=0&id=4b54d1dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b54d1dd",
  null
  
)

export default component.exports